module.exports = __webpack_public_path__ + "static/media/tangent.222b4f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/tangent.jpg
// module id = 324
// module chunks = 0